import React from 'react';

const ChatIcon = ({showNewUI = false, fillColor = '#424242', size = '40'}) =>
  showNewUI ? (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 19 18"
      fill="none">
      <path
        stroke={fillColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        strokeWidth={1.2}
        d="M17.667 4.208v4.25c0 1.059-.35 1.95-.975 2.567-.617.625-1.509.975-2.567.975v1.508c0 .567-.633.909-1.1.592l-.808-.533c.075-.259.108-.542.108-.842V9.333c0-1.7-1.133-2.833-2.833-2.833H3.833c-.116 0-.225.008-.333.017V4.208C3.5 2.083 4.917.667 7.042.667h7.083c2.125 0 3.542 1.416 3.542 3.541Z"
      />
      <path
        stroke={fillColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        strokeWidth={1.2}
        d="M12.325 9.333v3.392c0 .3-.033.583-.108.842-.309 1.225-1.325 1.991-2.725 1.991H7.225l-2.517 1.675a.56.56 0 0 1-.875-.466v-1.209c-.85 0-1.558-.283-2.05-.775-.5-.5-.783-1.208-.783-2.058V9.333c0-1.583.983-2.675 2.5-2.816.108-.009.217-.017.333-.017h5.659c1.7 0 2.833 1.133 2.833 2.833Z"
      />
    </svg>
  ) : (
    <svg
      id="Chat"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 72 72">
      <circle
        id="Ellipse_703"
        data-name="Ellipse 703"
        cx="36"
        cy="36"
        r="36"
        fill="rgba(41,97,250,0)"
      />
      <path
        id="Path_65854"
        data-name="Path 65854"
        d="M377.159,25.348a1.264,1.264,0,0,1-.8-.288L370.649,20.3h-5.939a10.1,10.1,0,1,1,0-20.2h11.164A10.1,10.1,0,0,1,378.4,19.944v4.12a1.25,1.25,0,0,1-1.263,1.263ZM364.711,2.627a7.574,7.574,0,1,0,0,15.147H371.1a1.263,1.263,0,0,1,.8.288l3.99,3.323V18.935a1.263,1.263,0,0,1,1.085-1.263A7.553,7.553,0,0,0,375.9,2.627Z"
        transform="translate(-328.338 18.046)"
        fill={fillColor}
      />
      <rect
        id="Rectangle_16073"
        data-name="Rectangle 16073"
        width="2.719"
        height="2.719"
        rx="1.29"
        transform="translate(32.918 26.713)"
        fill={fillColor}
      />
      <rect
        id="Rectangle_16074"
        data-name="Rectangle 16074"
        width="2.719"
        height="2.719"
        rx="1.29"
        transform="translate(40.526 26.713)"
        fill={fillColor}
      />
      <rect
        id="Rectangle_16075"
        data-name="Rectangle 16075"
        width="2.719"
        height="2.719"
        rx="1.29"
        transform="translate(48.14 26.713)"
        fill={fillColor}
      />
      <path
        id="Path_65855"
        data-name="Path 65855"
        d="M347.773,40.4a1.285,1.285,0,0,1-.529-.11,1.263,1.263,0,0,1-.728-1.154V35.02a10.1,10.1,0,0,1-1.62-18.938,1.263,1.263,0,1,1,1.181,2.232l-.144.069a7.553,7.553,0,0,0,2.019,14.42,1.257,1.257,0,0,1,1.085,1.257V36.51l3.99-3.317a1.27,1.27,0,0,1,.81-.343h6.358a7.464,7.464,0,0,0,5.418-2.3,1.27,1.27,0,0,1,1.82,1.772h0a10.114,10.114,0,0,1-7.237,3.056h-5.932l-5.644,4.738A1.284,1.284,0,0,1,347.773,40.4Z"
        transform="translate(-322.766 12.467)"
        fill={fillColor}
      />
    </svg>
  );

export default ChatIcon;
